import voteReportApi from '~/clientApis/reportApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { getStore } from '~/mobx/AppStore';
import sortUserVotes from '~/serverUtils/sortUserVotes';

export const getStandAdminUserVoteListByRegion = async () => {
    const { regionStore, reportStore, generalSettingsStore } = getStore();
    const year = generalSettingsStore.getSelectedElectionYear();
    const requestParams = {
        region_id: regionStore.selectedRegionId,
        year: year,
    };

    reportStore.setIsLoadingStandAdminUserVoteList(true);

    try {
        const response = await voteReportApi.getStandAdminUserVoteListByRegion(requestParams);
        const sortedVotes = sortUserVotes(response.stand_admins);
        reportStore.setStandAdminUserVoteList(sortedVotes);
    } catch (error) {
        const errorMessage =
            (await (error as Response).json()).error ||
            'Error fetching stand admin user vote list by region id: ' + regionStore.selectedRegionId;
        showMessageModal('error', errorMessage);
    } finally {
        reportStore.setIsLoadingStandAdminUserVoteList(false);
    }
};
